import Vue from 'vue'

export const JustDigits = () => {
	Vue.directive('digitsonly', (el, binding) => {
		if (/[\d\.]+/i.test(el.value)) {
		} else {
			let newValue = el.value.replace(/[a-zA-Z]+/ig, '');
			el.value = newValue;
			binding.value = el.value;
		}
	});
	Vue.directive('validstring', (el, binding) => {
		// console.log(el);
			let newValue = el.value.replace(/[^a-zA-Z0-9]/g, "");
			console.log(newValue);
			el.value = newValue;
			binding.value = el.value;
	});
};



// WEBPACK FOOTER //
// ./src/components/filter.js